import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const EditCapsuleCycle = (props) => {
  const {
    capsule,
    capsule_other,
    editCapsule,
    handleCapsuleCycleEditChange,
    displayEditCapsulePerCycle,
    handleOtherCapsChange,
    DropdownIndicator,
    form,
    capsulePerCycle,
  } = props;

  return (
    <React.Fragment>
      {editCapsule[capsule] !== true ? (
        displayEditCapsulePerCycle(capsule)
      ) : (
        <Select
          menuShouldScrollIntoView={false}
          classNamePrefix="margin-custom-select custom-select"
          components={{
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          onChange={(e) =>
            handleCapsuleCycleEditChange(capsule, capsule_other, e)
          }
          options={capsulePerCycle}
          placeholder="Select"
        />
      )}
      {editCapsule[capsule_other] && (
        <div className="col">
          <input
            type="number"
            onChange={(e) => handleOtherCapsChange(e, capsule, capsule_other)}
            value={parseInt(form && form[capsule_other]) || ""}
            name={capsule_other}
            min="1"
          />
        </div>
      )}
    </React.Fragment>
  );
};

EditCapsuleCycle.propTypes = {
  capsule: PropTypes.string,
  capsule_other: PropTypes.string,
  editCapsule: PropTypes.object,
  handleCapsuleCycleEditChange: PropTypes.func,
  displayEditCapsulePerCycle: PropTypes.func,
  handleOtherCapsChange: PropTypes.func,
  DropdownIndicator: PropTypes.func,
  form: PropTypes.object,
  capsulePerCycle: PropTypes.array,
};

export default EditCapsuleCycle;
